import React, { useMemo, useState } from "react";
import { ClickAwayListener, Popper } from "@mui/material";
import { flexRender } from "@tanstack/react-table";
import CellContainer from "../cellContainer";
import PricingGuidanceCard from "../../BulkReprice/PricingGuidanceCard";
import { cn } from "../../../utils/utils";

const ConfidenceCell = ({ cell }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const confidenceValue = cell.getValue();
    const normalizedConfidence =
    typeof confidenceValue === "string"
    ? confidenceValue.trim().toLowerCase()
    : "";
    const badgeClass = cn(
    "text-[0.6rem] px-1 py-0.5 rounded border font-semibold capitalize inline-flex items-center justify-center min-w-[40px]",
    normalizedConfidence.startsWith("high") &&
    "bg-green-50 text-green-700 border-green-300",
    normalizedConfidence.startsWith("med") &&
    "bg-amber-50 text-amber-700 border-amber-300",
    normalizedConfidence.startsWith("low") &&
    "bg-red-50 text-red-700 border-red-300"
);

  const guidanceData = useMemo(() => {
    const source = cell?.row?.original ?? {};
    return {
      confidence: source["Confidence"],
      bandLow: source["Band Low"],
      bandHigh: source["Band High"],
      suggested: source["Suggested Price"],
      ask: source["$/Ct"],
      bestComp: source["Best Compition Price"],
      direction: source["Direction"],
      position: source["Position"],
      ppcPredicted: source["PPC Predicted"],
      ppcPredictedFrom: source["PPC Predicted From"],
      ppcPredictedTo: source["PPC Predicted To"],
    };
  }, [cell?.row?.original]);

  const hasGuidance = useMemo(() => {
      const { bandLow, bandHigh, suggested, position } = guidanceData;
      return [bandLow, bandHigh, suggested, position].some(
        (value) => value !== null && value !== undefined && value !== ""
      );
    }, [guidanceData]);

  const handleMouseEnter = (event) => {
    if (!hasGuidance) return;
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  return (
    <>
      <Popper
        open={Boolean(anchorEl) && hasGuidance}
        anchorEl={anchorEl}
        placement="bottom"
        style={{ zIndex: 1000 }}
        
      >
        <ClickAwayListener onClickAway={handleClose}>
           <div className="w-full bg-white border border-[#cbcbcb] rounded-xl px-1 py-2 shadow-md">
            <PricingGuidanceCard band={guidanceData} />
          </div>
        </ClickAwayListener>
      </Popper>
      <td
        key={cell.id}
        className="h-10"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleClose}
      >
        <CellContainer className="text-[0.685rem] font-medium mt-1 justify-center px-1 text-end">
            <span className={badgeClass}>
                {flexRender(
                    cell.column.columnDef.cell,
                    cell.getContext()
                )}
            </span>
        </CellContainer>
      </td>
    </>
  );
};

export default ConfidenceCell;

